import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import ToolbarOption from '@/checkout-instore-legacy/components/Commons/Elements/ToolbarOption'

export default function GiftNotifier({ selectableGifts, onClick }) {
  if (!selectableGifts || selectableGifts.length === 0) {
    return <div />
  }

  return (
    <ToolbarOption
      id="giftnotifier"
      icon="fa-gift"
      isEmpty={false}
      onClick={onClick}
    >
      <FormattedMessage id="gifts" />
    </ToolbarOption>
  )
}

GiftNotifier.propTypes = {
  selectableGifts: PropTypes.array,
  onClick: PropTypes.func,
}
